import { useEffect, useRef, useState } from "react";
import BuildingModel from "../components/building-model.tsx";
import PropertyInput from "../components/inputs/input-property.tsx";
import InputSelectGebaeudetyp from "../components/inputs/input-select-gebaeudetyp.tsx";
import View, {H, ViewCopy, ViewDialog} from "../components/view.tsx";
import { useStore } from "../state/state.ts";
import BuildingModelFull from "../components/building-model-full.tsx";
import BuildingGeometryData from "../components/building_geometry_data.tsx";

export default function ViewBase1() {
  return <ViewBase1FormFull />
}

export function ViewBase1FormFull() {
  const timeout = useRef(null);
  const [adress, set_address] = useState<[string, string, string]>(["", "", ""]);
  const glb_url_store = useStore((state) => state.glb_url);
  const features = useStore((state) => state.features);
  const postleitzahl = useStore((state) => state.postleitzahl);
  const strasse = useStore((state) => state.strasse);
  const hausnummer = useStore((state) => state.hausnummer);
  const get_property = useStore((state) => state.get_property);
  const has_feature = useStore((state) => state.has_feature);
  const api_building_geometry = useStore((state) => state.api_building_geometry);

  const update_geometry = async ()=>{
      console.log(has_feature('geo3d'),postleitzahl, hausnummer, strasse );

      if (has_feature('geo3d') && (postleitzahl != adress[0] || strasse != adress[1] || hausnummer != adress[2]) && postleitzahl != undefined && strasse != undefined && hausnummer != undefined) {
        set_address([postleitzahl, strasse, hausnummer]);
        await api_building_geometry();
      }
    }
  useEffect(()=>{
    if (timeout.current) {
      clearTimeout(timeout.current)
    }

    timeout.current = setTimeout(update_geometry, 1500);
  },[postleitzahl, strasse, hausnummer]);

  if (has_feature('geo3d') === true){
    return (<View>
            <div className="layout">
              <div className="layout__background">
                 <BuildingModelFull/>
              </div>
              <div className="layout__col layout__col-left" style={{zIndex: 2,  width: "30rem",  minWidth: "30rem"}}>
                <ViewCopy><H>Wie ist die Adresse der Immobilie?</H></ViewCopy>
                <PropertyInput placeholder_prefix="z.B." type={"postleitzahl"}/>
                <PropertyInput placeholder_prefix="z.B." type={"strasse"}/>
                <PropertyInput placeholder_prefix="z.B." type={"hausnummer"}/>
                <InputSelectGebaeudetyp/>
                <BuildingGeometryData/>
              </div>
          </div>
      </View>);
  }else if (has_feature('geo3d') === false){
    return (<View>
      <ViewCopy><H>Um welches Gebäude handelt es sich?</H></ViewCopy>
      <PropertyInput type="gebaeude_typ"/> 
    </View>);
  }else{
    return (<View>
    </View>);
  }
}
